import { gql } from '@apollo/client'

export const SEND_MESSAGE_TO_EVENT = gql`
    mutation SendMessageToEvent($input: sendMessageToEventInput!) {
        sendMessageToEvent(input: $input) {
            success
        }
    }
`
